module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "search-item"
  }, [(_vm.collection === 'wwf-au-web') ? _c('search-item-web', {
    attrs: {
      "item": _vm.item
    }
  }) : (_vm.collection === 'wwf-au-faq') ? _c('search-item-faq', {
    attrs: {
      "item": _vm.item
    }
  }) : (_vm.collection === 'wwf-au-youtube') ? _c('search-item-youtube', {
    attrs: {
      "item": _vm.item
    }
  }) : (_vm.collection === 'wwf-au-instagram') ? _c('search-item-instagram', {
    attrs: {
      "item": _vm.item
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6744e1bd","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-webpack-plugin/loader.js?id=os8u77dxteg!./~/string-replace-webpack-plugin/loader.js?id=zkc3fbyssup!./src/components/search/SearchItem.vue
// module id = 656
// module chunks = 0